import React, { memo } from 'react';

import { ItemsTable } from 'ui/components/Table/ItemsTable';

import { ReportsPageTableProps } from './types';
import { REPORTS_COLUMNS } from './consts';

import FBOTitleBar from 'ui/theme/components/FBOTitleBar/FBOTitleBar';

const ReportsPageTable: React.FC<ReportsPageTableProps> = (props) => {
  const {
    items,
    activeId,
    onReportClick,
    hasSearchTerm,
    totalReportsAvailable,
  } = props;

  const alwaysOnColumns = REPORTS_COLUMNS.filter((c) => c.title === 'Name');
  const getEmptyTableMessage = () => {
    if (
      hasSearchTerm &&
      items.length === 0 &&
      (totalReportsAvailable ?? 0) > 0
    ) {
      return "No reports found matching your search or you don't have access to the requested report";
    }
    return 'No reports available';
  };

  return (
    <>
      <FBOTitleBar title="Reports" />

      <ItemsTable
        data={items}
        columns={activeId ? alwaysOnColumns : REPORTS_COLUMNS}
        activeId={activeId}
        selectableItems={false}
        onItemClick={onReportClick}
        dataQa="reports"
        emptyTableText={getEmptyTableMessage()}
      />
    </>
  );
};
export default memo(ReportsPageTable);
